document.addEventListener('DOMContentLoaded', function() {
  // Select the form within the #create-customer div
  var form = document.querySelector('#create-customer form'); // Use this selector to find the form
  var marketingCheckbox = document.getElementById('marketing');

  if (form && marketingCheckbox) {
    form.addEventListener('submit', function(event) {
      if (!marketingCheckbox.checked) {
        alert('You must agree to receive marketing emails to register.');
        event.preventDefault(); // Prevent form submission if checkbox is not checked
      }
    });
  } else {
    console.error('Form or marketing checkbox not found.');
  }
});
